module.exports = __webpack_public_path__ + "static/img/8areaA_03.f5d9175.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/8areaA_03.png
// module id = 1050
// module chunks = 1